import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { Check } from "lucide-react"
import type { ContentLanguage } from "./SettingsControls"

/** "EN ✓ · DE pending": which languages of a text are written. */
export function LanguageStatus({
  needsWriting,
}: {
  needsWriting: Record<ContentLanguage, boolean>
}) {
  const { translate } = useTranslation()
  const languages: ContentLanguage[] = ["en", "de"]
  return (
    <span className="flex flex-wrap items-center gap-x-1.5 text-xs text-muted-foreground">
      {languages.map((language, index) => (
        <span key={language} className="flex items-center gap-1">
          {index > 0 && <span aria-hidden>·</span>}
          <span className="font-medium text-foreground">
            {language.toUpperCase()}
          </span>
          {needsWriting[language] ? (
            <>
              <span aria-hidden className="size-1.5 rounded-full bg-warning" />
              {translate("SETTINGS/SETUP/LANGUAGE_PENDING")}
            </>
          ) : (
            <>
              <Check aria-hidden className="size-3.5" />
              <span className="sr-only">
                {translate("SETTINGS/SETUP/LANGUAGE_DONE")}
              </span>
            </>
          )}
        </span>
      ))}
    </span>
  )
}
